import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export var voteInPoll = createAction("".concat(actionTypePrefix, ".POLL_VOTE"), function (payload) { return payload; });
export var voteInPollFail = createAction("".concat(actionTypePrefix, ".POLL_VOTE_FAIL"), function (payload) { return payload; });
export var voteInPollSuccess = createAction("".concat(actionTypePrefix, ".POLL_VOTE_SUCCESS"), function (payload) { return payload; });
//# sourceMappingURL=actionCreators.js.map